<!-- @format -->

<div class="recipient-card" [attr.id]="cardId">
    <div class="recipient-card__header">
        <div>
            <h4 class="card-title">{{ title }}</h4>
            <p class="card-subtitle">{{ subtitle }}</p>
        </div>
        <button type="button" class="card-toggle" (click)="toggleExpanded.emit()" aria-label="Toggle recipients">
            <img src="../../../assets/dropdown.svg" alt="toggle" [ngClass]="{ expanded: expanded }" />
        </button>
    </div>

    <div class="recipient-card__body" *ngIf="expanded">
        <div class="option-header">
            <input type="checkbox" class="recipient-checkbox" [checked]="appUserSelected"
                (change)="appUserToggle.emit()" />
            <div>
                <p class="option-title">Application User</p>
                <p class="option-hint">Select from user listing</p>
            </div>
        </div>

        <div class="option-content" *ngIf="appUserSelected">
            <app-recipient-selector [users]="users" [selectedUsers]="selectedUsers"
                (selectionChange)="selectionChange.emit($event)"></app-recipient-selector>
        </div>

        <div class="option-header">
            <input type="checkbox" class="recipient-checkbox" [checked]="uploadedRefFileSelected"
                (change)="refFileToggle.emit()" />
            <div>
                <p class="option-title">Reference File</p>
                <p class="option-hint">Upload a CSV file</p>
            </div>
        </div>

        <div class="option-content" *ngIf="uploadedRefFileSelected">
            <div class="upload-row">
                <input type="file" #fileInput accept=".csv" (change)="fileSelected.emit($event)"
                    style="display: none" />
                <button type="button" class="upload-csv-btn" (click)="fileInput.click()">
                    Upload CSV File
                </button>
                <div class="upload-status" [ngClass]="{ placeholder: !showUploadStatus }">
                    <div class="upload-status__row">
                        <span class="upload-filename">{{ uploadedFileName }}</span>
                        <span class="upload-percent">
                            {{ uploadStatus === 'complete' ? 'Complete' : uploadProgress + '%' }}
                        </span>
                    </div>
                    <div class="upload-progress">
                        <div class="upload-progress__bar" [ngClass]="{ complete: uploadStatus === 'complete' }"
                            [style.width.%]="uploadProgress"></div>
                    </div>
                </div>
            </div>
            <p class="csv-cta">
                Not sure what to include?
                <span class="csv-cta__link" (click)="downloadSample.emit()">
                    Sample CSV file
                </span>
            </p>
            <div class="file-status">
                <p class="file-upload-status">
                    <strong>File Uploaded</strong>:
                    {{ uploadedFileName || 'None' }}
                </p>
                <p class="validation-message" [ngClass]="csvValidated ? 'success-message' : 'error-message'"
                    *ngIf="validationMessage">
                    {{ validationMessage }}
                </p>
            </div>
        </div>
    </div>
</div>